/**
 * Library helper.
 * - Show/hide the filter options.
 * - Update message text to show the number of active filters.
 *
 * @author Brian McGill <github.com/bmcgill>
 */

(function ($) {
  'use strict';

  Drupal.behaviors.initializeLibrary = {
    attach: (context) => {
      if (context === document) initialize();
    },
  };

  function initialize() {
    const $filter = $('.library .filter');
    const $filterText = $filter.find('.message .text');
    const $filterClose = $filter.find('.message .close');

    // Buttons to show and hide filter options.
    $filterText.click(function () {
      $filter.addClass('active');
      $('body').addClass('library-filter-active');
      // Position filter message bar at top of window.
      $('html, body').animate({
        scrollTop: $('.library').offset().top - $('header').height() - 20,
      });
    });
    $filterClose.click(function () {
      $filter.removeClass('active');
      $('body').removeClass('library-filter-active');
    });
  }
})(jQuery);
